export enum DeviceType {
  WebAndMobile = "webAndMobile",
  Web = "web",
  Mobile = "mobile",
}
